/**
 * @description 灰度用户配置 ABUserConfig
 * @author 系统生成
 * @date 2018/9/20
 */

import Logic from '../logic-base'

const ABUserConfigBiz = new Logic()

ABUserConfigBiz.deleteUser = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.ABUserConfig.deleteUser,
    data: data
  })
}

ABUserConfigBiz.releaseUser = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.ABUserConfig.releaseUser,
    data: data
  })
}

ABUserConfigBiz.rollBack = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.ABUserConfig.rollBack,
    data: data
  })
}

ABUserConfigBiz.createUser = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.ABUserConfig.createUser,
    data: data
  })
}

ABUserConfigBiz.allSwitch = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.ABUserConfig.allSwitch,
    data: data
  })
}

ABUserConfigBiz.findUser = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.ABUserConfig.findUser,
    data: data
  })
}

ABUserConfigBiz.downloadTemplate = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.ABUserConfig.downloadTemplate,
    data: data
  })
}

ABUserConfigBiz.uploadTemplate = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.ABUserConfig.uploadTemplate,
    data: data
  })
}

export default ABUserConfigBiz
